export * from './context-item.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/context/context-item/index.ts